import React, { useEffect, useState } from "react";
import styles from "./customer-namespace-string-nav.module.scss";
import {
  errorSnackbar,
  successSnackbar,
} from "@src/cloud-connect/snackbars/entities/snackbar-launcher";
import { TextButton } from "@src/components/atoms/buttons/text-button/text-button";
import {
  ToolTip,
  ToolTipPositionType,
} from "@src/components/atoms/tooltip/tooltip";
import { useI18N } from "@src/language/language-context";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";

interface CustomerNamespaceStringNavProps {
  tooltipPosition: ToolTipPositionType;
}
const cssClassName = "customer-namespace-string-nav";

export const CustomerNamespaceStringNav = ({
  tooltipPosition,
}: CustomerNamespaceStringNavProps) => {
  const i18n = useI18N();

  const authContext = useSelector(
    (state: RootState) => state.yourSlice.authContext,
  );

  const texts = {
    linkText: i18n("modules.customerNamespaceString.linkText"),
    copySuccessText: i18n("modules.customerNamespaceString.copySuccessText"),
    copyErrorText: i18n("modules.customerNamespaceString.copyErrorText"),
    toolTipText: i18n("modules.customerNamespaceString.toolTipText"),
  };

  const [customerNamespace, setCustomerNamespace] = useState("");

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      successSnackbar(texts.copySuccessText);
    } catch (err) {
      console.error(`${texts.copyErrorText}: `, err);
      errorSnackbar(`${texts.copyErrorText}: ${err}`, 5000);
    }
  };

  const handleClick = () => {
    copyToClipboard(customerNamespace);
  };

  useEffect(() => {
    if (authContext) {
      setCustomerNamespace(authContext.customerNamespace);
    }
  }, [authContext]);

  return (
    <div className={styles[cssClassName]}>
      <ToolTip content={texts.toolTipText} position={tooltipPosition}>
        <span
          className={styles[`${cssClassName}__link-text`]}
        >{`${texts.linkText}`}</span>
        <br />
        <TextButton clickHandler={handleClick} text={customerNamespace} />
      </ToolTip>
    </div>
  );
};
